module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery-dynamix"
  }, [_c('div', {
    staticClass: "gallery-container",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_vm._l((_vm.segments), function(segment, segmentIndex) {
    return _c('div', {
      staticClass: "tile is-ancestor"
    }, [(segment.selection === 0) ? _c('div', {
      staticClass: "tile is-parent tx_type_0"
    }, _vm._l((segment.items), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })) : (segment.selection === 1 || segment.selection === 2) ? _c('div', {
      staticClass: "tile is-parent tx_type_1-2"
    }, _vm._l((segment.items), function(item, index) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h",
        class: {
          'is-4 tx_full_h1': (segment.selection === 1 && index == 0) || (segment.selection === 2 && index == 1),
          'is-8 tx_full_h3': (segment.selection === 1 && index == 1) || (segment.selection === 2 && index == 0)
        }
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })) : (segment.selection === 3 || segment.selection === 5) ? _c('div', {
      staticClass: "tile is-parent tx_type_3or5"
    }, [_vm._l(([segment.items[0]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h",
        class: {
          'is-4 tx_full_h2': segment.selection === 3, 'is-8 tx_full_h1': segment.selection === 5
        }
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical",
      class: {
        'is-4': segment.selection === 5, 'is-8': segment.selection === 3
      }
    }, [_vm._l(([segment.items[1]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.items[2]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })], 2)], 2) : (segment.selection === 4 || segment.selection === 6) ? _c('div', {
      staticClass: "tile is-parent tx_type_4or6"
    }, [_c('div', {
      staticClass: "tile is-vertical",
      class: {
        'is-8': segment.selection === 4, 'is-4': segment.selection === 6
      }
    }, [_vm._l(([segment.items[0]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.items[1]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.items[2]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h",
        class: {
          'is-8 tx_full_h1': segment.selection === 6, 'is-4 tx_full_h2': segment.selection === 4
        }
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })], 2) : (segment.selection >= 7 && segment.selection <= 10) ? _c('div', {
      staticClass: "tile is-parent tx_type_7to10"
    }, [_vm._l(([segment.items[3]]), function(item) {
      return (segment.selection === 9 || segment.selection === 10) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical is-8"
    }, [_vm._l(([segment.items[0]]), function(item) {
      return (segment.selection === 7 || segment.selection === 9) ? _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-parent"
    }, [_vm._l(([segment.items[1]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child is-6 tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.items[2]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child is-6 tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.items[0]]), function(item) {
      return (segment.selection === 8 || segment.selection === 10) ? _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])]) : _vm._e()
    })], 2), _vm._v(" "), _vm._l(([segment.items[3]]), function(item) {
      return (segment.selection === 7 || segment.selection === 8) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])]) : _vm._e()
    })], 2) : (segment.selection >= 11 && segment.selection <= 13) ? _c('div', {
      staticClass: "tile is-parent tx_type_11to13"
    }, [_vm._l(([segment.items[4]]), function(item) {
      return (segment.selection === 12) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical is-4 segment-11"
    }, [_vm._l(([segment.items[0]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.items[1]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.items[4]]), function(item) {
      return (segment.selection === 13) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical is-4"
    }, [_vm._l(([segment.items[2]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.items[3]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.items[4]]), function(item) {
      return (segment.selection === 11) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])]) : _vm._e()
    })], 2) : _c('div', {
      staticClass: "tile is-parent"
    }, _vm._l((segment.items), function(item) {
      return _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    }))])
  }), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d9e5a96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryDynamix.vue
// module id = 831
// module chunks = 1